import { render, staticRenderFns } from "./SidebarDesktop.vue?vue&type=template&id=53a4f6ca&scoped=true"
import script from "./SidebarDesktop.vue?vue&type=script&lang=js"
export * from "./SidebarDesktop.vue?vue&type=script&lang=js"
import style0 from "./SidebarDesktop.vue?vue&type=style&index=0&id=53a4f6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a4f6ca",
  null
  
)

export default component.exports